// The inventory lists: an ingredient is counted at inventory time by giving it one of these
// categories, which is what puts it on the printed checklist for that list. They are also the
// categories ticked by default in the category export dialog.
export const INVENTORY_CATEGORIES = ['dairy', 'drystore', 'frozen', 'office', 'protein', 'veg'];

// the inventory lists an ingredient is printed on - empty when it is not counted at all
export function inventoryListsOf(ingredient) {
  const categories = (ingredient && ingredient.categories) || [];
  return INVENTORY_CATEGORIES.filter(list => categories.includes(list));
}

export function isInInventory(ingredient) {
  return inventoryListsOf(ingredient).length > 0;
}
